import moment from 'moment-timezone';

export const getCreatedAtStr = (data: string, timeFormat = 'h:mm a') => {
  const mData = moment(data);
  return `${mData.format('L')}, ${mData.format(timeFormat)}`;
};
